module.exports = __webpack_public_path__ + "static/media/monitor_tasks.03f03bab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/monitor_tasks.svg
// module id = 178
// module chunks = 0